import { CascadiaColor } from "@certn/cascadia-tokens";
import { Name, formatName, getRandomItem } from "@certn/utils";

import { AvatarColors, BaseColors } from "./types";

export function getAvatarColors(color: AvatarColors) {
  const backgroundColor: CascadiaColor =
    color === "neutral"
      ? "background-accent-neutral-medium"
      : `background-accent-${color}-strong`;
  const iconColor: CascadiaColor =
    color === "neutral"
      ? "background-accent-neutral-strong"
      : `background-accent-${color}-weak`;
  const fontColor: CascadiaColor =
    color === "neutral" ? "text-weak" : "text-inverse";

  return { fontColor, iconColor, backgroundColor };
}

/**
 * Picks a random colour based on a user's name.
 * @param name the avatar's name
 * @returns tofino if no name is provided, otherwise a random colour
 */
export function generateRandomAvatarColour(name?: Name): AvatarColors {
  return getRandomItem(BaseColors, formatName(name));
}
